import React, { useState, useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import Loader from "../../../components/Loader";
import Introduction from "./Introduction";
import Features from "./Features";
import Achievements from "./Achievements";
import StatusOfGeneration from "./StatusOfGeneration";
import ContactPerson from "./ContactPerson";
import PhotoGallery from "./PhotoGallery";
import InnerBannerBreadcrumb from "../../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useSelector } from "react-redux";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";
import { useGetProtectedApiDataQuery } from "../../../redux/services/apiSlice";
import DamVideoGallery from "./DamVideoGallery";
import {
  extractDateFromStr,
  getLatestDateFromData,
} from "../../../Utils/utils";
import PageLastUpdated from "../../../components/shared/PageLastUpdated";

const PowerDetailPage = () => {
  const { getText } = useLanguageTranslation();
  const { id, type } = useParams();

  const { powerTabStr, languageType } = useSelector((state) => state.homeSlice);
  const { data: energyAssetsData = [], isLoading: energyAssetsIsLoading } =
    useGetProtectedApiDataQuery({ url: "energy-assets", lang: languageType });

  const [activeTab, setActiveTab] = useState("introduction");

  const handleClick = (tabName) => (event) => {
    event.preventDefault();
    setActiveTab(tabName);
  };

  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    const loaderTimeout = setTimeout(() => {
      setShowLoader(false);
    }, 1000); // Show loader for 1 second

    return () => clearTimeout(loaderTimeout);
  }, []); // Runs once on component mount

  const energyAssetsObj = energyAssetsData?.find((item) => item.nid === id);

  const lastUpdatedOn = useMemo(() => {
    return getLatestDateFromData(energyAssetsObj);
  }, [energyAssetsObj]);

  const getTitle2 = (text) => {
    if (text === "Hydro Power" && languageType === "hi") {
      return `जल विद्युत`;
    } else if (text === "Thermal Power" && languageType === "hi") {
      return `ताप विद्युत`;
    } else if (text === "Solar Power" && languageType === "hi") {
      return `सौर ऊर्जा`;
    } else if (text === "Hydro Power" && languageType === "") {
      return `Hydro Power`;
    } else if (text === "Thermal Power" && languageType === "") {
      return `Thermal Power`;
    } else if (text === "Solar Power" && languageType === "") {
      return `Solar Power`;
    }
  };

  if (energyAssetsIsLoading || showLoader) {
    return <Loader />;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage={energyAssetsObj.field_image_banner}
        title={getText("Power Generation", "विद्युत उत्पादन")}
        titleLink="/power-generation"
        levelTwo={true}
        titleTwo={getTitle2(energyAssetsObj?.field_category_page_assets)}
        levelThree={true}
        titleLink2={`/power-generation/${type}`}
        isActive={energyAssetsObj?.title}
        titleThree={energyAssetsObj?.title}
      />

      <div className="inner-container">
        <div className="container">
          <div className="container">
            {/* <div className="title-sec mb-4">
              <h4>{energyAssetsObj.title}</h4>
            </div> */}
            <div className="row">
              <div className="col-12 col-sm-12 col-md-3 col-lg-3">
                <div className="innleft_section">
                  <ul className="menu nav nav-pills flex-column">
                    <li className="nav-item">
                      <a
                        href="#"
                        className={`nav-link ${
                          activeTab === "introduction" ? "active" : ""
                        }`}
                        onClick={handleClick("introduction")}
                      >
                        {getText("Introduction", "परिचय")}
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        href="#"
                        className={`nav-link ${
                          activeTab === "features" ? "active" : ""
                        }`}
                        onClick={handleClick("features")}
                      >
                        {getText("Features", "विशेषताएँ")}
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        href="#"
                        className={`nav-link ${
                          activeTab === "achievements" ? "active" : ""
                        }`}
                        onClick={handleClick("achievements")}
                      >
                        {getText("Achievements", "उपलब्धियों")}
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        href="#"
                        className={`nav-link ${
                          activeTab === "status-of-generation" ? "active" : ""
                        }`}
                        onClick={handleClick("status-of-generation")}
                      >
                        {getText("Status of Generation", "उत्पदान की स्थिति")}
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        href="#"
                        className={`nav-link ${
                          activeTab === "contact-person" ? "active" : ""
                        }`}
                        onClick={handleClick("contact-person")}
                      >
                        {getText("Contact Person", "संपर्क व्यक्ति")}
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        href="#"
                        className={`nav-link ${
                          activeTab === "photo-gallery" ? "active" : ""
                        }`}
                        onClick={handleClick("photo-gallery")}
                      >
                        {getText("Photo Gallery", "फोटो गैलरी")}
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        href="#"
                        className={`nav-link ${
                          activeTab === "video-gallery" ? "active" : ""
                        }`}
                        onClick={handleClick("video-gallery")}
                      >
                        {getText("Video Gallery", "वीडियो गैलरी")}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-12 col-sm-12 col-md-9 col-lg-9">
                {activeTab === "introduction" && (
                  <Introduction data={energyAssetsObj?.field_introduction} />
                )}
                {activeTab === "features" && (
                  <Features data={energyAssetsObj?.field_education} />
                )}
                {activeTab === "achievements" && (
                  <Achievements
                    data={energyAssetsObj?.field_medical_health_care_and_sa}
                  />
                )}

                {activeTab === "status-of-generation" && (
                  <StatusOfGeneration
                    data={energyAssetsObj.field_project_name}
                  />
                )}
                {activeTab === "contact-person" && (
                  <ContactPerson
                    data={energyAssetsObj?.field_swachh_bharat_and_swachh_v}
                  />
                )}
                {activeTab === "photo-gallery" && (
                  <PhotoGallery data={energyAssetsObj?.field_photo_gallery} />
                )}
                {activeTab === "video-gallery" && (
                  <DamVideoGallery
                    data={energyAssetsObj?.field_video_gallery}
                  />
                )}
              </div>
            </div>
            <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
          </div>
        </div>
      </div>
    </>
  );
};

export default PowerDetailPage;
